/**
 * @Author: zhengpengcheng
 * @Description:
 * @DateTime: Created in 2022-11-09 14:23:00
 */

import {Component} from 'vue-property-decorator'
import SolutionKeyService from "./service/solutionKeyService";
import BasicSearchPage from "../../../components/basicSearchPage/basicSearchPage";
import override from "../../../dectorators/override";
import { TestDOI } from './api/testApi';

@Component
export default class SolutionKey extends BasicSearchPage<SolutionKeyService, TestDOI.RowDataI, TestDOI.QueryRowDataParamsI> {
    checkBoxShow = false
    className='wqms-pt0'
	@override
	loadService () {
        this.service = new SolutionKeyService(this)
    }
    
}